module.exports = __webpack_public_path__ + "static/img/3.66e4b76f.jpg";